const ENV_SYSTEM = process.env;

export const FIREBASE_CONFIG = {
  API_KEY: ENV_SYSTEM.REACT_APP_FIREBASE_API_KEY,
  AUTH_DOMAIN: ENV_SYSTEM.REACT_APP_FIREBASE_AUTH_DOMAIN,
  PROJECT_ID: ENV_SYSTEM.REACT_APP_FIREBASE_PROJECT_ID,
  STORAGE_BUCKET: ENV_SYSTEM.REACT_APP_FIREBASE_STORAGE_BUCKET,
  MESSAGING_SENDER_ID: ENV_SYSTEM.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  APP_ID: ENV_SYSTEM.REACT_APP_FIREBASE_APP_ID,
};

export const BACKEND_URL = ENV_SYSTEM.REACT_APP_BACKEND_URL;
